import { render, staticRenderFns } from "./Redenvelopes.vue?vue&type=template&id=5009de72&scoped=true&"
import script from "./Redenvelopes.vue?vue&type=script&lang=js&"
export * from "./Redenvelopes.vue?vue&type=script&lang=js&"
import style0 from "./Redenvelopes.vue?vue&type=style&index=0&id=5009de72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5009de72",
  null
  
)

export default component.exports